<template>
    <div class="ios-prompt" v-if="showPrompt">
        <img :src="pwaLogo" width="35" height="35">
        <p v-if="isSafari" v-html="$t('front.pwa.install_message')"></p>
        <p v-else v-html="$t('front.pwa.ios_message')"></p>
        <span>&times;</span>
    </div>
</template>

<script>
import {brandName} from "../../../config/app";
import VueCookies from "vue-cookies";

export default {
    name: "PwaPopup",

    data: function () {
        return {
            isSafari: false,
            iosPromptTimer: null,
            showPrompt: true,
        };
    },

    computed: {
        pwaLogo() {
            return `/public/${brandName}/mobile-icons/48x48.png`;
        },
    },

    mounted() {
        // Detects if device is in standalone mode
        const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);

        // Checks if should display install popup notification
        if (this.isIos() && !isInStandaloneMode() && !VueCookies.get('ios-prompt')) {
            //this.showPrompt = true;
            this.showIosInstall();
        } else {
            this.showPrompt = false;
        }

        // Checks if browser is Safari
        this.isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
            navigator.userAgent &&
            navigator.userAgent.indexOf('CriOS') == -1 &&
            navigator.userAgent.indexOf('FxiOS') == -1;
    },

    methods: {
        // Show popup for installing the App
        showIosInstall() {
            let iosPrompt = document.querySelector('.ios-prompt');
            let closeBtn = document.querySelector('.ios-prompt > span');
            let lastScrollTop = 0;
            let self = this;
            iosPrompt.style.opacity = 1;
            iosPrompt.style.zIndex = 6;

            this.iosPromptTimer = setTimeout(function () {
                iosPrompt.style.opacity = 0;
                iosPrompt.style.zIndex = 0;
                self.showPrompt = false;
            }, 1000 * 60 * 2);

            closeBtn.addEventListener('click', function closePwaPopup() {
                iosPrompt.style.opacity = 0;
                iosPrompt.style.zIndex = 0;
                self.showPrompt = false;
                VueCookies.set('ios-prompt', 1, 1000 * 60 * 60 * 24);
                window.removeEventListener('scroll', closePwaPopup, false);
            });

            window.addEventListener("scroll", function () {
                if (VueCookies.get('ios-prompt')) return;

                let st = window.pageYOffset || document.documentElement.scrollTop;
                iosPrompt.style.opacity = st > lastScrollTop ? 0 : 1;
                iosPrompt.style.zIndex = st > lastScrollTop ? 0 : 999999;
                lastScrollTop = st <= 0 ? 0 : st;
                clearTimeout(self.iosPromptTimer);
                self.iosPromptTimer = null;

                this.iosPromptTimer = setTimeout(function () {
                    iosPrompt.style.opacity = 0;
                    iosPrompt.style.zIndex = 0;
                    self.showPrompt = false;
                }, 1000 * 60 * 2);
            }, false);
        },

        // Detects if device is on iOS
        isIos() {
            if (/iPad|iPhone|iPod/.test(navigator.platform)) {
                return true;
            } else {
                return navigator.maxTouchPoints &&
                    navigator.maxTouchPoints > 2 &&
                    /MacIntel/.test(navigator.platform);
            }
        },
    }
}
</script>

<style lang="sass">
@import "sass/components/popups/PwaPopup"
</style>